let threeLoadPromise = null;

const THREE_CDN_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
const THREE_LOAD_TIMEOUT_MS = 15000;

export const ensureThreeJS = () => {
  if (window.THREE) return Promise.resolve(window.THREE);
  if (threeLoadPromise) return threeLoadPromise;

  threeLoadPromise = new Promise((resolve, reject) => {
    let script = document.querySelector('script[data-threejs-cdn="true"]');
    let timeoutId;

    const cleanup = () => {
      window.clearTimeout(timeoutId);
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };
    const fail = (message) => {
      cleanup();
      script.remove();
      threeLoadPromise = null;
      reject(new Error(message));
    };
    const handleLoad = () => {
      if (!window.THREE) {
        fail('El motor 3D terminó de descargar, pero no pudo iniciarse.');
        return;
      }
      cleanup();
      resolve(window.THREE);
    };
    const handleError = () => fail('No se pudo descargar el motor 3D.');

    const shouldAppendScript = !script;
    if (shouldAppendScript) {
      script = document.createElement('script');
      script.src = THREE_CDN_URL;
      script.dataset.threejsCdn = 'true';
    }

    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });
    timeoutId = window.setTimeout(() => {
      fail('El motor 3D tardó demasiado en responder.');
    }, THREE_LOAD_TIMEOUT_MS);
    if (shouldAppendScript) document.head.appendChild(script);
  });

  return threeLoadPromise;
};
